<span [ngbTooltip]="bitstreamName" placement="top-left">{{ bitstreamName }}</span>
